var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAlertInactive = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#E02D52",
  fillRule: "evenodd",
  d: "M10 2.068c.28 0 .562.14.722.417l8.196 14.197a.834.834 0 0 1-.721 1.25H1.803a.834.834 0 0 1-.721-1.25L9.278 2.485A.83.83 0 0 1 10 2.068m0 2.5L3.247 16.265h13.506zm0 10.849a.834.834 0 1 1 .002-1.668.834.834 0 0 1-.002 1.668m.833-3.334a.836.836 0 0 1-.833.834.836.836 0 0 1-.833-.834V8.75c0-.458.375-.833.833-.833s.833.375.833.833z"
})));
export { SvgAlertInactive as ReactComponent };
export default __webpack_public_path__ + "img/alert-inactive.a14d4320945e0e7b6e87233720a2c1d8.svg";